import * as joint from 'jointjs';
// 线的基类
export const BaseLink = joint.shapes.standard.Link.define('mst.BaseLink', {
  attrs: {
    // '.connection': { stroke: 'lime' },
    // '.marker-target': { d: 'M 10 0 L 0 5 L 10 10 z', fill: 'lime', stroke: 'lime' },
    // '.marker-arrowhead': { d: 'M 10 0 L 0 5 L 10 10 z' },
    // '.marker-arrowhead-group-source .marker-arrowhead': { d: 'M 0 0 L 10 0 L 10 10 L 0 10 z' },
    // '.marker-vertices .marker-vertex': { r: '5' },
    // '.link-tools': { display: 'none' }
    // line: { targetMarker: { fill: 'lime' } }
  }
});

export const BaseLinkView = joint.dia.LinkView.extend({
  initialize() {
    joint.dia.LinkView.prototype.initialize.apply(this, []);
  }
});
